
export default class CarCostChart extends HTMLDivElement {

    chart = null;

    get chartElement() {
        return this.querySelector("canvas");
    }

    get tableElement() {
        return this.querySelector("table");

    }

    initChart(Chart) {
        this.chart = new Chart(this.chartElement,
            {
                type: 'line',
                options: {
                    locale: "sv-se",
                    plugins: {
                        annotation: {
                            annotations: {
                                box1: {
                                    type: 'box',
                                    drawTime: 'beforeDatasetsDraw',
                                    xMin: 1,
                                    xMax: 10,
                                    yMin: 10000,
                                    yMax: 50000,
                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                    borderColor: 'rgba(0,0,0,0)'
                                }
                            }
                        },
                        legend: {
                            fontFamily: "'Open Sans', sans-serif",
                            position: 'bottom'
                        },
                        title: {
                            display: true,
                            text: 'Värdeminskning över tid'
                        },
                        tooltip: {
                            callbacks: {
                                title: (items) => {
                                    return `${items[0].label} år`;
                                },
                                label: (item) =>
                                    `${item.dataset.label}: ${item.formattedValue} kr`,
                            },
                        },
                    },
                    scales: {
                        y: {

                            ticks: {
                                callback: function (value, index, values) {

                                    const formatter = new Intl.NumberFormat('sv-SE', {
                                        style: 'currency',
                                        currency: 'SEK',
                                        maximumFractionDigits: 0
                                    });

                                    return formatter.format(value);
                                }
                            }
                        },
                        x: {
                            ticks: {
                                callback: function (value, index, values) {
                                    return value + " år";
                                }
                            }
                        }
                    }


                }
            }
        );
    }

    update(price, yearssincemanufactured, yearstokeep) {

        if (price < 1000 || yearssincemanufactured < 0 || yearstokeep < 0)
            return;

        if (this.chart === null) {
            let Chart;
            import("chart.js/auto").then(module => {
                Chart = module.default;
                import("chartjs-plugin-annotation").then(module => {
                    Chart.register(module.default);
                    this.initChart(Chart);
                    this.updateChart(price, yearssincemanufactured, yearstokeep);
                });
                
            });

        }
        else {
            this.updateChart(price, yearssincemanufactured, yearstokeep);
        }
    }

    updateChart(price, yearssincemanufactured, yearstokeep) {

        const years = 21;

        let highprice, mediumprice, lowprice;

        let yearlabels = [],
            high = [],
            medium = [],
            low = [];

        for (let i = 0; i < years; i++) {

            if (i == 0) {
                highprice = price * Math.pow(0.8, -yearssincemanufactured);
                mediumprice = price * Math.pow(0.84, -yearssincemanufactured);
                lowprice = price * Math.pow(0.88, -yearssincemanufactured);
            }
            else {
                highprice = highprice * 0.8;
                mediumprice = mediumprice * 0.84;
                lowprice = lowprice * 0.88;
            }

            high.push(Math.round(highprice));
            medium.push(Math.round(mediumprice));
            low.push(Math.round(lowprice));

            this.tableElement.querySelector("tbody").append(
                '<tr><td>År' + (i + 1) + '</td><td>Låg värdeminskning:' + Math.round(lowprice) + 'kronor</td><td>Normal värdeminskning:' + Math.round(mediumprice) + 'kronor</td><td>Hög värdeminskning:' + Math.round(highprice) + 'kronor</td></tr>'
            );

            yearlabels.push(i);
        }

        this.chart.data.labels.pop();
        this.chart.data.labels = yearlabels;

        this.chart.data.datasets.forEach((dataset) => {
            dataset.data.pop();
        });

        this.chart.data.datasets = [{
            data: high,
            label: "Hög ",
            borderColor: "#e00034",
            fill: false
        },
        {
            data: medium,
            label: "Normal ",
            borderColor: "#5e4a7a",
            fill: false
        },
        {
            data: low,
            label: "Låg",
            borderColor: "#609f60",
            fill: false
            }];

        let marker = this.chart.options.plugins.annotation.annotations.box1;

        marker.xMin = yearssincemanufactured;

        if ((yearssincemanufactured + yearstokeep) < years) {
            marker.xMax = (yearssincemanufactured + yearstokeep);
        }
        else {
            marker.xMax = years - 1;
        }

        if (price >= 140000) {
            marker.yMax = price;
        }
        else {
            marker.yMax = 140000;
        }

        this.chart.update();

        this.classList.remove("d-none");
    }

    disconnectedCallback() {

        this.chart.destroy();
        this.chart = null;

    }

}

customElements.define('car-cost-chart', CarCostChart, { extends: 'div' });